import RealFullData from './RealFull.data'

const RealScatterData = RealFullData

export default RealScatterData
